var exports = {
  "Nr": "x43aef4ae--568419--card",
  "Sl": "x43aef4ae--568419--image",
  "Qq": "x43aef4ae--568419--text",
  "At": "x43aef4ae--568419--text__inner",
  "El": "x43aef4ae--568419--image--desktop",
  "Lw": "x43aef4ae--568419--overlay",
  "PW": "x43aef4ae--568419--overlay__inner",
};

module.exports = exports;
